// extracted by mini-css-extract-plugin
export var ignore = "_6u-1";
export var mapping = "_6u-0";
export var range = "_6u-4";
export var savings = "_6u-3";
export var settings = "_6u-2";